import { useTemplateRead } from "@/lib/template-queries";

export const useTemplateById = (id: string) => useTemplateRead(id);
